import SystemEmailEditor from '@Components/General/SystemEmailEditor';
import {
    useMutation,
    useQueryClient,
    useSuspenseQuery,
} from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import { emailTemplateQueryOptions } from '@utils/queryOptions';
import { useTranslation } from 'react-i18next';

const EditTemplate = () => {
    const { t } = useTranslation();
    const { templateId } = useParams({});
    const queryClient = useQueryClient();
    const { data } = useSuspenseQuery(emailTemplateQueryOptions(templateId));

    const updateTemplate = useMutation({
        mutationKey: ['updateEmailTemplate'],
    });

    const handleSave = data => {
        return updateTemplate.mutate([templateId, data]);
    };

    const handleSaveAndInvalidate = async data => {
        await updateTemplate.mutateAsync([templateId, data]);
        queryClient.invalidateQueries({
            queryKey: ['emailTemplateVariants'],
            refetchType: 'all',
        });
    };

    return (
        <SystemEmailEditor
            initialData={data?.template || undefined}
            onSave={handleSave}
            saving={updateTemplate.isPending}
            title={data?.title || t('Untitled Template')}
            setTitle={title => handleSaveAndInvalidate({ title })}
            selectTamplateOpen={!data?.template}
        />
    );
};

export default EditTemplate;
